import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import EchoInstance from '../../../../../../_metronic/_helpers/echo'; // Adjust path as needed

import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderToolbar,
} from '../../../../../../_metronic/_partials/controls';
import { CardSpinner } from '../../../../../widgets/cardSpinner/CardSpinner';
import * as actions from './../../../redux/scada/ScadaActions';
import { ScadaShowVarTable } from './components/ScadaShowVarTable';
import { ScadaShowProject } from './components/ScadaShowProject';
import { ScadaShowChart } from './components/ScadaShowChart';

const TAB_NAMES = {
  project: 0,
  variables: 1,
  trends: 2,
};

export const ScadaShowCard = ({ id }) => {
  const [tableData, setTableData] = useState([]);

  const [layoutCount, setLayoutCount] = useState(1);

  const [selectedTab, setSelectedTab] = useState(TAB_NAMES.project);

  const { currentState } = useSelector(state => ({ currentState: state.scada }));

  const { scadaShowEntity, scadaShowLoading, scadaShowVarEntities } = currentState;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getScadaShow({ id: id }));
    dispatch(actions.getScadaShowVar({ id: id }));
  }, [dispatch, id]);

  useEffect(() => {
    if (scadaShowEntity.real_id !== undefined && Object.keys(scadaShowVarEntities).length !== 0) {
      setLayoutCount(scadaShowEntity.layout_count);
      const channel = EchoInstance.private(`scada.${scadaShowEntity.real_id}`); // Or .private()
      channel.listen('.Scada\\Events\\ScadaTagsUpdated', data => {
        setTableData(prevData =>
          prevData.map(item => (item.id === data[0].id ? { ...item, tag_value: data[0].last_value } : item)),
        );
      });
      return () => {
        channel.stopListening('.Scada\\Events\\ScadaTagsUpdated'); // Clean up on unmount
      };
    }
  }, [scadaShowEntity, scadaShowVarEntities]);
  useEffect(() => {
    setTableData(
      scadaShowVarEntities.map(item => {
        return { ...item, tag_value: item.last_value };
      }),
    );
  }, [scadaShowVarEntities]);

  const currentTab = useMemo(() => {
    return [
      <ScadaShowProject id={id} />,
      <ScadaShowVarTable layoutCount={layoutCount} tableDataEntities={tableData} />,
      <ScadaShowChart id={id} />,
      'Раздел находится в разработке!',
    ][selectedTab];
  }, [id, selectedTab, tableData, layoutCount]);

  return (
    <>
      {scadaShowLoading && <CardSpinner />}
      <Card>
        <CardHeader
          headerClassName="card-header-tabs-line"
          title={`Объект диспетчеризации: ${scadaShowEntity.title ? scadaShowEntity.title : ''}`}
        >
          <CardHeaderToolbar>
            <ul className="nav nav-tabs nav-bold nav-tabs-line">
              <li className="nav-item">
                <span
                  className={`nav-link cursor-pointer ${selectedTab === TAB_NAMES.project ? 'active' : ''}`}
                  onClick={() => setSelectedTab(TAB_NAMES.project)}
                >
                  <span className="nav-icon">
                    <i className="flaticon2-chat-1"></i>
                  </span>
                  <span className="nav-text">Проект</span>
                </span>
              </li>
              <span className="nav-item">
                <span
                  className={`nav-link cursor-pointer ${selectedTab === TAB_NAMES.variables ? 'active' : ''}`}
                  onClick={() => setSelectedTab(TAB_NAMES.variables)}
                >
                  <span className="nav-icon">
                    <i className="flaticon2-drop"></i>
                  </span>
                  <span className="nav-text">Переменные</span>
                </span>
              </span>
              <span className="nav-item">
                <span
                  className={`nav-link cursor-pointer ${selectedTab === TAB_NAMES.trends ? 'active' : ''}`}
                  onClick={() => setSelectedTab(TAB_NAMES.trends)}
                >
                  <span className="nav-icon">
                    <i className="flaticon2-drop"></i>
                  </span>
                  <span className="nav-text">Тренды</span>
                </span>
              </span>
            </ul>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>{currentTab}</CardBody>
        <CardFooter />
      </Card>
    </>
  );
};
